import { create } from 'zustand'
import { IUser } from '../@types/user'

type UserStore = {
  user: IUser | null
  promoModal: IUser | null
  setUser: (user?: IUser) => void
  setPromoModal: (promoModal: IUser) => void
  clearUser: () => void
  clearPromoModal: () => void
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  promoModal: null,
  clearUser: () => set({ user: null }),
  setUser: (user) => set({ user }),
  setPromoModal: (promoModal) => set({ promoModal }),
  clearPromoModal: () => set({ promoModal: null }),
}))
